// // src/pages/HourlySalesPage.jsx
// import React, { useEffect, useMemo, useRef, useState } from "react";
// import styled from "styled-components";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { FaSyncAlt } from "react-icons/fa";
// import { downloadCSV, downloadPDF, printThermal } from "../utils/exportHelpers";

// const COLOR = {
//   primary: "#015b9a",
//   bg: "#f5f7fb",
//   card: "#ffffff",
//   line: "#e5e7eb",
//   text: "#0f172a",
//   muted: "#6b7280",
// };

// const HOURS = Array.from({ length: 24 }, (_, i) => i);

// const HourlySalesPage = () => {
//   const [userId, setUserId] = useState(null);
//   const [fromDate, setFromDate] = useState(defaultFrom());
//   const [toDate, setToDate] = useState(today());
//   const [grid, setGrid] = useState([]);
//   const [totalsByHour, setTotalsByHour] = useState([]);
//   const [totalsByDate, setTotalsByDate] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [refreshing, setRefreshing] = useState(false);
//   const reportRef = useRef(null);

//   useEffect(() => {
//     const data = JSON.parse(localStorage.getItem("userData") || "{}")?.data;
//     if (!data?.id) {
//       toast.error("User not found. Please login again.");
//       setLoading(false);
//       return;
//     }
//     setUserId(data.id);
//   }, []);

//   useEffect(() => {
//     if (userId) fetchReport();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [userId, fromDate, toDate]);

//   const fetchReport = async (opts = {}) => {
//     if (!userId) return;
//     opts.refresh ? setRefreshing(true) : setLoading(true);
//     try {
//       const res = await fetch("https://qr.billsarthi.in/public/api/report/hourly-sales", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           restaurantid: userId,
//           fromdate: fromDate,
//           todate: toDate,
//         }),
//       });
//       const json = await res.json();
//       if (!res.ok) throw new Error(json?.message || "Failed to load report");
//       setGrid(Array.isArray(json?.grid) ? json.grid : []);
//       setTotalsByHour(Array.isArray(json?.totals_by_hour) ? json.totals_by_hour : []);
//       setTotalsByDate(Array.isArray(json?.totals_by_date) ? json.totals_by_date : []);
//     } catch (e) {
//       toast.error(e.message || "Unable to load hourly sales");
//       setGrid([]);
//       setTotalsByHour([]);
//       setTotalsByDate([]);
//     } finally {
//       opts.refresh ? setRefreshing(false) : setLoading(false);
//     }
//   };

//   const { dateKeys, cellLookup, maxAmount } = useMemo(() => {
//     const dates = [];
//     const map = {};
//     let max = 0;
//     grid.forEach((row) => {
//       if (!dates.includes(row.date)) dates.push(row.date);
//       map[`${row.date}-${row.hour}`] = row;
//       if (row.amount > max) max = row.amount;
//     });
//     dates.sort();
//     return { dateKeys: dates, cellLookup: map, maxAmount: max };
//   }, [grid]);

//   const fmtINR = (n) =>
//     `₹${Number(n || 0).toLocaleString("en-IN", {
//       minimumFractionDigits: 0,
//       maximumFractionDigits: 0,
//     })}`;

//   const calcIntensity = (amount) => {
//     if (!maxAmount || maxAmount <= 0) return 0.18;
//     const ratio = Math.min(1, amount / maxAmount);
//     return 0.18 + ratio * 0.65;
//   };

//   return (
//     <Page>
//       <ToastContainer position="top-right" autoClose={2200} />
//       <Top>
//         <div>
//           <Title>Hourly Sales</Title>
//           <Sub>Heatmap of orders by hour and date.</Sub>
//         </div>
//         <Actions>
//           <DateInput>
//             From:
//             <input type="date" value={fromDate} max={toDate} onChange={(e) => setFromDate(e.target.value)} />
//           </DateInput>
//           <DateInput>
//             To:
//             <input type="date" value={toDate} min={fromDate} onChange={(e) => setToDate(e.target.value)} />
//           </DateInput>
//           <PrimaryBtn onClick={() => fetchReport({ refresh: true })}>
//             <FaSyncAlt /> {refreshing ? "Refreshing..." : "Refresh"}
//           </PrimaryBtn>
//         </Actions>
//       </Top>

//       <Card ref={reportRef}>
//         {loading ? (
//           <Center>Loading…</Center>
//         ) : dateKeys.length === 0 ? (
//           <Center>No data for this range.</Center>
//         ) : (
//           <>
//             <HeatGrid>
//               <thead>
//                 <tr>
//                   <th>Date</th>
//                   {HOURS.map((h) => (
//                     <th key={h}>{String(h).padStart(2, "0")}</th>
//                   ))}
//                   <th>Total</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {dateKeys.map((d) => (
//                   <tr key={d}>
//                     <td className="date">{d}</td>
//                     {HOURS.map((h) => {
//                       const row = cellLookup[`${d}-${h}`];
//                       const amt = Number(row?.amount || 0);
//                       const intensity = calcIntensity(amt);
//                       return (
//                         <td
//                           key={`${d}-${h}`}
//                           style={{
//                             background: `rgba(1,91,154,${intensity})`,
//                             color: intensity > 0.45 ? "#fff" : "#0f172a",
//                           }}
//                         >
//                           {row ? fmtINR(row.amount) : "—"}
//                         </td>
//                       );
//                     })}
//                     <td className="total">
//                       {fmtINR(totalsByDate.find((t) => t.date === d)?.amount || 0)}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </HeatGrid>

//             <TotalsGrid>
//               <TotalsCard>
//                 <small>Totals by Hour</small>
//                 <div className="row">
//                   {HOURS.map((h) => {
//                     const amt = totalsByHour.find((t) => Number(t.hour) === h)?.amount || 0;
//                     return (
//                       <span key={h}>
//                         {String(h).padStart(2, "0")}h: {fmtINR(amt)}
//                       </span>
//                     );
//                   })}
//                 </div>
//               </TotalsCard>
//             </TotalsGrid>
//           </>
//         )}
//         <Actions style={{ marginTop: 10 }}>
//           <PrimaryBtn
//             onClick={() =>
//               downloadPDF(
//                 reportRef.current,
//                 `hourly_sales_${fromDate}_to_${toDate}.pdf`
//               )
//             }
//           >
//             <FaSyncAlt /> PDF
//           </PrimaryBtn>
//           <PrimaryBtn
//             onClick={() => {
//               const headers = ["Date", ...HOURS.map((h) => `${String(h).padStart(2, "0")}h`), "Total"];
//               const rows = dateKeys.map((d) => {
//                 const row = HOURS.map((h) => {
//                   const cell = cellLookup[`${d}-${h}`];
//                   return cell ? cell.amount : "";
//                 });
//                 const total = totalsByDate.find((t) => t.date === d)?.amount || 0;
//                 return [d, ...row, total];
//               });
//               downloadCSV(`hourly_sales_${fromDate}_to_${toDate}.csv`, headers, rows);
//             }}
//           >
//             <FaSyncAlt /> CSV
//           </PrimaryBtn>
//         </Actions>
//       </Card>
//     </Page>
//   );
// };

// export default HourlySalesPage;

// const today = () => {
//   const d = new Date();
//   const pad = (v) => String(v).padStart(2, "0");
//   return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
// };
// const defaultFrom = () => {
//   const d = new Date();
//   d.setDate(d.getDate() - 6);
//   return todayFromDate(d);
// };
// const todayFromDate = (d) => {
//   const pad = (v) => String(v).padStart(2, "0");
//   return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
// };

// /* ---------------- styled ---------------- */
// const Page = styled.div`
//   background: ${COLOR.bg};
//   min-height: 100vh;
//   padding: 16px;
// `;
// const Top = styled.div`
//   display: flex;
//   justify-content: space-between;
//   gap: 12px;
//   flex-wrap: wrap;
//   margin-bottom: 12px;
// `;
// const Title = styled.h1`
//   margin: 0;
//   font-size: 1.2rem;
//   font-weight: 900;
//   color: ${COLOR.text};
// `;
// const Sub = styled.div`
//   color: ${COLOR.muted};
// `;
// const Actions = styled.div`
//   display: flex;
//   gap: 8px;
//   align-items: center;
//   flex-wrap: wrap;
// `;
// const DateInput = styled.label`
//   display: inline-flex;
//   align-items: center;
//   gap: 6px;
//   padding: 8px 10px;
//   border: 1px solid ${COLOR.line};
//   border-radius: 10px;
//   background: #f9f9f9;
//   color: ${COLOR.text};
//   input {
//     border: 0;
//     background: transparent;
//     outline: none;
//   }
// `;
// const PrimaryBtn = styled.button`
//   display: inline-flex;
//   align-items: center;
//   gap: 6px;
//   padding: 10px 12px;
//   border-radius: 10px;
//   border: none;
//   background: ${COLOR.primary};
//   color: #fff;
//   font-weight: 800;
//   cursor: pointer;
// `;
// const Card = styled.div`
//   background: ${COLOR.card};
//   border: 1px solid ${COLOR.line};
//   border-radius: 16px;
//   padding: 14px;
//   box-shadow: 0 10px 26px rgba(0, 0, 0, 0.05);
// `;
// const HeatGrid = styled.table`
//   width: 100%;
//   border-collapse: collapse;
//   font-size: 13px;
//   th,
//   td {
//     border: 1px solid ${COLOR.line};
//     padding: 8px;
//     text-align: center;
//   }
//   thead {
//     background: #eef2ff;
//   }
//   .date {
//     font-weight: 800;
//     color: ${COLOR.text};
//   }
//   .total {
//     font-weight: 800;
//   }
// `;
// const TotalsGrid = styled.div`
//   margin-top: 12px;
// `;
// const TotalsCard = styled.div`
//   border: 1px solid ${COLOR.line};
//   border-radius: 12px;
//   padding: 10px;
//   background: #f8fafc;
//   .row {
//     display: flex;
//     flex-wrap: wrap;
//     gap: 8px;
//     margin-top: 6px;
//     color: ${COLOR.muted};
//   }
// `;
// const Center = styled.div`
//   text-align: center;
//   color: ${COLOR.muted};
//   padding: 16px;
// `;
// src/pages/HourlySalesPage.jsx
import React, { useEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaSyncAlt, FaFileInvoice } from "react-icons/fa";
import { downloadCSV, downloadExcel, downloadPDF, printThermal } from "../utils/exportHelpers";
import { formatStoredMoney } from "../utils/currency";
import ReportPeriodPicker from "../components/ReportPeriodPicker";
import ReportPageHeader from "../components/ReportPageHeader";
import ReportControlBar from "../components/ReportControlBar";
import { API_BASE_URL } from "../config/constants";

const COLOR = {
  primary: "#015b9a",
  bg: "#f5f7fb",
  card: "#ffffff",
  line: "#e5e7eb",
  text: "#0f172a",
  muted: "#6b7280",
};

const HOURS = Array.from({ length: 24 }, (_, i) => i);

const HourlySalesPage = () => {
  const [userId, setUserId] = useState(null);
  const [restaurant, setRestaurant] = useState({});
  const [fromDate, setFromDate] = useState(defaultFrom());
  const [toDate, setToDate] = useState(today());
  const [grid, setGrid] = useState([]);
  const [totalsByHour, setTotalsByHour] = useState([]);
  const [totalsByDate, setTotalsByDate] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const reportRef = useRef(null);

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("userData") || "{}")?.data;
    if (!data?.id) {
      toast.error("User not found. Please login again.");
      setLoading(false);
      return;
    }
    setUserId(data.id);
    setRestaurant(data || {});
  }, []);

  useEffect(() => {
    if (userId) fetchReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, fromDate, toDate]);

  const fetchReport = async (opts = {}) => {
    if (!userId) return;
    opts.refresh ? setRefreshing(true) : setLoading(true);
    try {
      const res = await fetch(
        `${API_BASE_URL}/report/hourly-sales`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            restaurantid: userId,
            fromdate: fromDate,
            todate: toDate,
          }),
        }
      );
      const json = await res.json();
      if (!res.ok) throw new Error(json?.message || "Failed to load report");
      setGrid(Array.isArray(json?.grid) ? json.grid : []);
      setTotalsByHour(
        Array.isArray(json?.totals_by_hour) ? json.totals_by_hour : []
      );
      setTotalsByDate(
        Array.isArray(json?.totals_by_date) ? json.totals_by_date : []
      );
    } catch (e) {
      toast.error(e.message || "Unable to load hourly sales");
      setGrid([]);
      setTotalsByHour([]);
      setTotalsByDate([]);
    } finally {
      opts.refresh ? setRefreshing(false) : setLoading(false);
    }
  };

  const { dateKeys, cellLookup, maxAmount } = useMemo(() => {
    const dates = [];
    const map = {};
    let max = 0;
    grid.forEach((row) => {
      if (!dates.includes(row.date)) dates.push(row.date);
      map[`${row.date}-${row.hour}`] = row;
      if (row.amount > max) max = row.amount;
    });
    dates.sort();
    return { dateKeys: dates, cellLookup: map, maxAmount: max };
  }, [grid]);

  const fmtINR = (n) => formatStoredMoney(n, { fractionDigits: 0 });

  const calcIntensity = (amount) => {
    if (!maxAmount || maxAmount <= 0) return 0.18;
    const ratio = Math.min(1, amount / maxAmount);
    return 0.18 + ratio * 0.65;
  };

  // Restaurant info for PDF header
  const restaurantName =
    restaurant.restaurant_name ||
    restaurant.restaurantname ||
    restaurant.name ||
    "Restaurant";

  const restaurantAddress =
    restaurant.addressline3 ||
    restaurant.address ||
    restaurant.restaurantaddress ||
    restaurant.city ||
    "";

  const restaurantPhone =
    restaurant.mobile_number ||
    restaurant.mobile ||
    restaurant.phone ||
    restaurant.contactnumber ||
    "";

  const generatedOn = useMemo(
    () =>
      new Date().toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }),
    []
  );

  return (
    <Page>
      <ToastContainer position="top-right" autoClose={2200} />
      <ReportPageHeader
        title="Hourly Sales"
        subtitle="Heatmap and breakdown of order sales by hour and date range."
      />

      <ReportControlBar>
        <ReportPeriodPicker fromDate={fromDate} toDate={toDate} onChange={({ from, to }) => { setFromDate(from); setToDate(to); }} />
        <PrimaryBtn onClick={() => fetchReport({ refresh: true })}>
          <FaSyncAlt /> {refreshing ? "Refreshing..." : "Refresh"}
        </PrimaryBtn>
      </ReportControlBar>

      <Card>
        {/* ✅ Only this inner div goes into PDF */}
        <div ref={reportRef}>
          {/* PDF Header */}
          <PdfHeaderCard>
            <PdfHeaderRow>
              <div className="left">
                <div className="resto">{restaurantName}</div>
                {restaurantAddress && (
                  <div className="line">{restaurantAddress}</div>
                )}
                {restaurantPhone && (
                  <div className="line">Phone: {restaurantPhone}</div>
                )}
              </div>
              <div className="right">
                <HeaderTitleRow>
                  <FaFileInvoice />
                  <h2>Hourly Sales Report</h2>
                </HeaderTitleRow>
                <div className="line">
                  Period: <strong>{fromDate}</strong> to{" "}
                  <strong>{toDate}</strong>
                </div>
                <div className="line">
                  Generated on: <strong>{generatedOn}</strong>
                </div>
              </div>
            </PdfHeaderRow>
          </PdfHeaderCard>

          {loading ? (
            <Center>Loading…</Center>
          ) : dateKeys.length === 0 ? (
            <Center>No data for this range.</Center>
          ) : (
            <>
              <HeatGrid>
                <thead>
                  <tr>
                    <th>Date</th>
                    {HOURS.map((h) => (
                      <th key={h}>{String(h).padStart(2, "0")}</th>
                    ))}
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {dateKeys.map((d) => (
                    <tr key={d}>
                      <td className="date">{d}</td>
                      {HOURS.map((h) => {
                        const row = cellLookup[`${d}-${h}`];
                        const amt = Number(row?.amount || 0);
                        const intensity = calcIntensity(amt);
                        return (
                          <td
                            key={`${d}-${h}`}
                            style={{
                              background: `rgba(1,91,154,${intensity})`,
                              color: intensity > 0.45 ? "#fff" : "#0f172a",
                            }}
                          >
                            {row ? fmtINR(row.amount) : "—"}
                          </td>
                        );
                      })}
                      <td className="total">
                        {fmtINR(
                          totalsByDate.find((t) => t.date === d)?.amount || 0
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </HeatGrid>

              <TotalsGrid>
                <TotalsCard>
                  <small>Totals by Hour</small>
                  <div className="row">
                    {HOURS.map((h) => {
                      const amt =
                        totalsByHour.find((t) => Number(t.hour) === h)
                          ?.amount || 0;
                      return (
                        <span key={h}>
                          {String(h).padStart(2, "0")}h: {fmtINR(amt)}
                        </span>
                      );
                    })}
                  </div>
                </TotalsCard>
              </TotalsGrid>

              {/* PDF Footer */}
              <PdfFooter>
                <span>Powered by</span>
                <strong>BillSarthi</strong>
              </PdfFooter>
            </>
          )}
        </div>

        {/* ✅ Buttons are outside reportRef, so not printed in PDF */}
        <Actions style={{ marginTop: 10 }}>
          <PrimaryBtn
            onClick={() =>
              downloadPDF(
                reportRef.current,
                `hourly_sales_${fromDate}_to_${toDate}.pdf`
              )
            }
          >
            <FaSyncAlt /> PDF
          </PrimaryBtn>
          <PrimaryBtn
            onClick={() =>
              printThermal(reportRef.current, `hourly_sales_${fromDate}_to_${toDate}`)
            }
          >
            Thermal Print
          </PrimaryBtn>
          <PrimaryBtn
            onClick={() => {
              const headers = [
                "Date",
                ...HOURS.map((h) => `${String(h).padStart(2, "0")}h`),
                "Total Sales",
              ];
              const rows = dateKeys.map((d) => {
                const row = HOURS.map((h) => {
                  const cell = cellLookup[`${d}-${h}`];
                  return cell ? Number(cell.amount || 0) : 0;
                });
                const total =
                  totalsByDate.find((t) => t.date === d)?.amount || 0;
                return [d, ...row, total];
              });
              downloadExcel(
                `hourly_sales_${fromDate}_to_${toDate}.xlsx`,
                headers,
                rows
              );
            }}
          >
            Excel
          </PrimaryBtn>
          <PrimaryBtn
            onClick={() => {
              const headers = [
                "Date",
                ...HOURS.map((h) => `${String(h).padStart(2, "0")}h`),
                "Total Sales",
              ];
              const rows = dateKeys.map((d) => {
                const row = HOURS.map((h) => {
                  const cell = cellLookup[`${d}-${h}`];
                  return cell ? Number(cell.amount || 0) : 0;
                });
                const total =
                  totalsByDate.find((t) => t.date === d)?.amount || 0;
                return [d, ...row, total];
              });
              downloadCSV(
                `hourly_sales_${fromDate}_to_${toDate}.csv`,
                headers,
                rows
              );
            }}
          >
            <FaSyncAlt /> CSV
          </PrimaryBtn>
        </Actions>
      </Card>
    </Page>
  );
};

export default HourlySalesPage;

const today = () => {
  const d = new Date();
  const pad = (v) => String(v).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};
const defaultFrom = () => {
  const d = new Date();
  d.setDate(d.getDate() - 6);
  return todayFromDate(d);
};
const todayFromDate = (d) => {
  const pad = (v) => String(v).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

/* ---------------- styled ---------------- */
const Page = styled.div`
  background: ${COLOR.bg};
  min-height: 100vh;
  padding: 16px;
`;
const Top = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 12px;
`;
const Title = styled.h1`
  margin: 0;
  font-size: 1.2rem;
  font-weight: 900;
  color: ${COLOR.text};
`;
const Sub = styled.div`
  color: ${COLOR.muted};
`;
const Actions = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
`;
const DateInput = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  border: 1px solid ${COLOR.line};
  border-radius: 10px;
  background: #f9f9f9;
  color: ${COLOR.text};
  input {
    border: 0;
    background: transparent;
    outline: none;
  }
`;
const PrimaryBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 12px;
  border-radius: 10px;
  border: none;
  background: ${COLOR.primary};
  color: #fff;
  font-weight: 800;
  cursor: pointer;
`;
const Card = styled.div`
  background: ${COLOR.card};
  border: 1px solid ${COLOR.line};
  border-radius: 16px;
  padding: 14px;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.05);
`;

/* ==== PDF Header / Footer ==== */
const PdfHeaderCard = styled.div`
  border-radius: 14px;
  border: 1px solid ${COLOR.line};
  padding: 10px 12px;
  margin-bottom: 12px;
  background: linear-gradient(90deg, #ffffff, #f5f7ff);
`;
const PdfHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: flex-start;
  .left {
    min-width: 180px;
  }
  .resto {
    font-size: 1.05rem;
    font-weight: 800;
    color: ${COLOR.primary};
    margin-bottom: 4px;
  }
  .line {
    color: ${COLOR.muted};
    font-size: 0.82rem;
  }
  .right {
    text-align: right;
  }
  @media (max-width: 720px) {
    flex-direction: column;
    .left {
      min-width: 0;
    }
    .right {
      text-align: left;
    }
  }
`;
const HeaderTitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-bottom: 4px;
  h2 {
    margin: 0;
    font-size: 1rem;
    font-weight: 800;
  }
`;
const PdfFooter = styled.div`
  margin-top: 12px;
  padding-top: 8px;
  border-top: 1px dashed ${COLOR.line};
  text-align: center;
  font-size: 11px;
  color: ${COLOR.muted};
  strong {
    color: ${COLOR.primary};
    margin-left: 4px;
  }
`;

const HeatGrid = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  th,
  td {
    border: 1px solid ${COLOR.line};
    padding: 8px;
    text-align: center;
  }
  thead {
    background: #eef2ff;
  }
  .date {
    font-weight: 800;
    color: ${COLOR.text};
  }
  .total {
    font-weight: 800;
  }
`;
const TotalsGrid = styled.div`
  margin-top: 12px;
`;
const TotalsCard = styled.div`
  border: 1px solid ${COLOR.line};
  border-radius: 12px;
  padding: 10px;
  background: #f8fafc;
  .row {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 6px;
    color: ${COLOR.muted};
  }
`;
const Center = styled.div`
  text-align: center;
  color: ${COLOR.muted};
  padding: 16px;
`;
